import { EventEmitter, Injectable } from '@angular/core';
import { EntityLoadedEventArgs, EntitySavedEventArgs, MessageBoxOptions, ToolbarSettings } from '@base/classes/BaseClasses';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { EnumFilterPanelActions, EnumMenuPositions } from './sysenums.enum';

@Injectable()
export class SysEventsService {
    // EventEmitter inherits from RxJS Subject. ALWAYS use subscribe/unsubscribe when working with them
    public OnSetDefaults: EventEmitter<boolean> = new EventEmitter();
    public OnEntityLoaded: EventEmitter<EntityLoadedEventArgs> = new EventEmitter();
    public OnNavigate: EventEmitter<string> = new EventEmitter();
    public OnReloadComponent: EventEmitter<string> = new EventEmitter();

    private _onEntitySavedSubject = new Subject<EntitySavedEventArgs>();
    public OnEntitySaved = this._onEntitySavedSubject.asObservable();

    NotifyEntitySaved(e: EntitySavedEventArgs) {
        this._onEntitySavedSubject.next(e);
    }

    private _toolbarReloadSubject = new ReplaySubject<ToolbarSettings>(3);
    readonly Toolbar = this._toolbarReloadSubject.asObservable();

    ReloadToolbar(toolbarSettings: ToolbarSettings) {
        this._toolbarReloadSubject.next(toolbarSettings);
    }

    private _selectedRouteChangedSubject = new BehaviorSubject('');
    readonly SelectedRoute = this._selectedRouteChangedSubject.asObservable();

    ChangeSelectedRoute(route: string) {
        this._selectedRouteChangedSubject.next(route);
    }

    private _reloadMenuItemsSubject = new ReplaySubject<boolean>(1); //BehaviorSubject(false);
    readonly MenuItems = this._reloadMenuItemsSubject.asObservable();

    ReloadMenuItems() {
        this._reloadMenuItemsSubject.next(true);
    }

    private _menuPositonSubject = new ReplaySubject<EnumMenuPositions>(1);
    readonly MenuPositon = this._menuPositonSubject.asObservable();

    // null or undefined to toggle menu
    SetMenuPositon(position?: EnumMenuPositions) {
        this._menuPositonSubject.next(position);
    }

    //private _toggleSidebarSubject = new Subject<{ sidebarName: string, pageComponentName: string, action: EnumSidebarActions, force: boolean }>();
    //readonly Sidebar = this._toggleSidebarSubject.asObservable();

    //SidebarAction(sidebarName: string, pageComponentName: string, action: EnumSidebarActions, force?: boolean) {
    //    this._toggleSidebarSubject.next({ sidebarName, pageComponentName, action, force });
    //}

    private _filterPanelSubject = new Subject<EnumFilterPanelActions>();
    readonly FilterPanel = this._filterPanelSubject.asObservable();

    FilterPanelAction(action: EnumFilterPanelActions) {
        this._filterPanelSubject.next(action);
    }

    private _pageSidePanelStateSubject = new ReplaySubject<{ pageComponentName: string, state: boolean }>(1);
    readonly PageSidePanelState = this._pageSidePanelStateSubject.asObservable();

    SetPageSidePanelState(pageComponentName: string, state: boolean) {
        this._pageSidePanelStateSubject.next({ pageComponentName: pageComponentName, state: state });
    }

    private _pagePreviewStateSubject = new Subject<{ pageComponentName: string, state: boolean, data: string | Blob, fileName: string }>();
    readonly PagePreviewState = this._pagePreviewStateSubject.asObservable();

    SetPagePreviewState(pageComponentName: string, state: boolean, data?: string | Blob, fileName?: string) {
        this._pagePreviewStateSubject.next({ pageComponentName: pageComponentName, state: state, data, fileName });
    }

    private _openMessageBoxSubject = new Subject<MessageBoxOptions>();
    readonly OpenMessageBoxSubject = this._openMessageBoxSubject.asObservable()

    public OpenMessageBox(options: MessageBoxOptions) {
        this._openMessageBoxSubject.next(options);
    }

    private _closeMessageBoxSubject = new Subject<boolean>();
    readonly CloseMessageBoxSubject = this._closeMessageBoxSubject.asObservable()

    public CloseMessageBox(value: boolean) {
        this._closeMessageBoxSubject.next(value);
    }

    private _breadcrumbSubject = new Subject<boolean>();
    readonly Breadcrumb = this._breadcrumbSubject.asObservable();

    public SetBreadCrumbVisible(isVisible: boolean) {
        this._breadcrumbSubject.next(isVisible);
    }

    private _defaultNavigationSubject = new Subject<boolean>();
    readonly OnNavigateDefault = this._defaultNavigationSubject.asObservable();

    public NavigateDefault(result: boolean) {
        this._defaultNavigationSubject.next(result);
    }

    private _loadPanelSubject = new Subject<boolean>();
    readonly LoadPanel = this._loadPanelSubject.asObservable();

    public SetLoadPanelState(result: boolean) {
        this._loadPanelSubject.next(result);
    }
}
